import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ModoLigaApp } from 'src/app/services/modo-liga-app';
declare var $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  public Url_privacidad: string;
  public Url_reglamento: string;
  public Url_terminos: string;
  public url_sitio: string;
  nombreColaborador: string = '';
  botonesDeshabilitados: boolean = false;
  mostrarToast: boolean = false;

  /** Entró por liga de la App: links del footer apagados para que no salga de su flujo de pago. */
  get modoLigaApp(): boolean {
    return ModoLigaApp.activo();
  }

  constructor(private router: Router) {
    this.Url_privacidad = environment.Url_Avisos_Privacidad;
    this.Url_reglamento = environment.Url_reglamento;
    this.Url_terminos = environment.Url_terminos;

    this.url_sitio = environment.Urlsitio;

  }

  ngOnInit() {
    // Escuchamos cambios de ruta para validar si debemos mostrar el aviso
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.validarRutaYColaborador(event.url);
    });
  }


  validarRutaYColaborador(urlActual: string) {
    const liga = sessionStorage.getItem('liga_compartida_colaborador');
    const nombre = sessionStorage.getItem('liga_compartida_nombre_colaborador');

    // Con el candado de liga (App o venta externa) no hay "ir a comprar" a otro lado:
    // el modal de "Tienes seleccionada la liga de..." no aplica.
    if (ModoLigaApp.activo()) {
      this.ocultarToast();
      return;
    }

    // SI no estamos en la página de boletos-colaborador Y existen los datos
    if (!urlActual.includes('boletos-colaborador') && !urlActual.includes('venta-digital-externa') &&  !urlActual.includes('carrito-compra') &&  !urlActual.includes('datos-comprador') &&  !urlActual.includes('forma-pago')&& !urlActual.includes('venta-exitosa') && !urlActual.includes('boletos-colaborador-anahuac-online') && !urlActual.includes('egresados-lealtad') && liga && nombre) {
      this.nombreColaborador = nombre;
      this.mostrarToast = true;
      this.botonesDeshabilitados = true;

      // Activamos el Toast de BS4
      setTimeout(() => $('#toastColaborador').toast('show'), 500);
    } else {
      this.ocultarToast();
    }

    if(urlActual.includes('boletos-colaborador-anahuac-online') || urlActual.includes('egresados-lealtad') || urlActual.includes('dia-del-nino')) {
      $(".sub-menu").css('display', 'none');
    }
  }

  irAComprar() {
    const liga = sessionStorage.getItem('liga_compartida_colaborador');
    this.botonesDeshabilitados = false;
    this.ocultarToast();

    if (liga) {
      // Redirección directa fuera del flujo de Angular
      window.location.href = liga;
    }
  }

  cancelarApoyo() {
    const confirmacion = `¿Seguro que no quieres comprar el boleto de ${this.nombreColaborador}? Perderás sus datos y ya no lo apoyarás.`;

    if (confirm(confirmacion)) {
      sessionStorage.removeItem('liga_compartida_colaborador');
      sessionStorage.removeItem('liga_compartida_nombre_colaborador');

      // Al cancelar el apoyo hay que olvidar TAMBIEN los boletos que venian de la
      // liga. Antes solo se quitaba el letrero: 'BoletosRecomendados' se quedaba
      // en la sesion y, al entrar despues a un carrito de venta digital, la purga
      // de verificaCarrito lo encontraba y soltaba un boleto que ya podia tener
      // una orden viva (referencia, OXXO o SPEI).
      //
      // Se borra SOLO lo de la liga. Nada de clear(): 'campaingData' es la
      // atribucion de campania y 'idcarrito' lo necesita el botecito de basura
      // para los boletos de venta digital que el comprador si quiera conservar.
      sessionStorage.removeItem('BoletosRecomendados');
      sessionStorage.removeItem('BoletosCol');
      sessionStorage.removeItem('pk_boleto_app');

      this.ocultarToast();
      this.botonesDeshabilitados = false; // O mantener true según tu lógica de negocio
      location.reload(); // Recargamos para limpiar estados globales si es necesario
    }
  }

  ocultarToast() {
    this.mostrarToast = false;
    $('#toastColaborador').toast('hide');
  }


}
